/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:06 GMT
 *
 */


const theme = {
  appearances: {
    focus: {
      description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    pressed: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    }
  },
  rules: [
    {
      if: { focus: true, pressed: true },
      tokens: { color: '#595959', outlineColor: '#595959' }
    }
  ],
  tokens: {
    backgroundColor: '#ffffff',
    borderRadius: 4,
    color: '#000000',
    fontName: 'StagSans',
    fontSize: 16,
    fontWeight: '600',
    lineHeight: 1.5,
    outlineColor: '#000000',
    outlineOffset: 0,
    outlineStyle: 'solid',
    outlineWidth: 2,
    paddingHorizontal: 2,
    paddingVertical: 2,
    textLine: 'underline'
  }
}
export default theme
